const actions = {
  SET_STATE: 'subscription/SET_STATE',
  START_SUBSCRIPTION: 'subscription/START_SUBSCRIPTION',
  GET_SUBSCRIPTION_STATUS: 'subscription/GET_SUBSCRIPTION_STATUS',
  GET_SUBSCRIPTION_HISTORY: 'subscription/GET_SUBSCRIPTION_HISTORY',
  GET_SUBSCRIPTION_DEDUCTIONS: 'subscription/GET_SUBSCRIPTION_DEDUCTIONS',
  CANCEL_SUBSCRIPTION: 'subscription/CANCEL_SUBSCRIPTION',
}

export default actions
